<svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z" fill="#2A3243"/>
  <path d="m8.001 17.2 4.4 4.4 11.6-11.6" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
